import React from 'react';
import { logInfoMessage } from '../../utils/sentry';
const defaultAnalyticsMethod = () => {
  // tslint:disable-next-line no-console
  // eslint-disable-next-line no-console
  console.warn('No analytics client has been provided.');
  logInfoMessage('Analytics Context accessed before AnalyticsClient was loaded');
};
export const defaultAnalyticsClient = {
  getAnalyticsWebClient: () => {
    defaultAnalyticsMethod();
    return;
  },
  pushTrackEvent: defaultAnalyticsMethod,
  pushScreenEvent: defaultAnalyticsMethod,
  pushUIEvent: defaultAnalyticsMethod,
  pushOperationalEvent: defaultAnalyticsMethod,
  startUIViewedEvent: defaultAnalyticsMethod,
  expTracker: () => {
    throw new Error('No analytics client has been provided');
  }
};
const AnalyticsContextState = {
  analytics: defaultAnalyticsClient
};
export const AnalyticsContext = /*#__PURE__*/React.createContext(AnalyticsContextState);